"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wordBlue = exports.white = exports.warning = exports.primary = exports.powerPointRed = exports.positive = exports.pdfRed = exports.neutral = exports.negative = exports.informative = exports.excelGreen = exports.default = exports.black = exports.backgroundGrey = void 0;
var primary = {
  10: '#F7F9FD',
  20: '#E5EDF8',
  30: '#C3D8EF',
  40: '#8DBDE1',
  50: '#4A9BD0',
  60: '#0076BD',
  70: '#0064A6',
  80: '#004F90',
  90: '#00377B',
  100: '#002167'
};
exports.primary = primary;
var neutral = {
  10: '#F7F7F7',
  20: '#F3F3F3',
  30: '#E9E9E9',
  40: '#E0E0E0',
  50: '#BDBDBD',
  60: '#9E9E9E',
  70: '#757575',
  80: '#616161',
  90: '#424242',
  100: '#212121'
};
exports.neutral = neutral;
var negative = {
  10: '#FDF7F6',
  20: '#FBEDE9',
  30: '#F5CEC7',
  40: '#EC9C95',
  50: '#E2605A',
  60: '#D9221C',
  70: '#AE1D15',
  80: '#881B0F',
  90: '#621B09',
  100: '#3A1504'
};
exports.negative = negative;
var positive = {
  10: '#F5FAF5',
  20: '#E8F2E6',
  30: '#C7E0C1',
  40: '#99C489',
  50: '#64A347',
  60: '#2B8000',
  70: '#216D00',
  80: '#165C00',
  90: '#0B4A00',
  100: '#013600'
};
exports.positive = positive;
var warning = {
  10: '#FCF8F3',
  20: '#F5EBDB',
  30: '#EBD1B4',
  40: '#DEAC81',
  50: '#CE7F44',
  60: '#BD4F00',
  70: '#943F00',
  80: '#6B3300',
  90: '#482800',
  100: '#352400'
};
exports.warning = warning;
var informative = {
  10: '#F5F7FC',
  20: '#E6EDF7',
  30: '#C1D7ED',
  40: '#89B9DC',
  50: '#4898C9',
  60: '#0274B6',
  70: '#005B93',
  80: '#004174',
  90: '#002A5A',
  100: '#001743'
};
exports.informative = informative;
var white = '#FFFFFF';
exports.white = white;
var black = '#000000';
exports.black = black;
var backgroundGrey = '#F7F7F7';
exports.backgroundGrey = backgroundGrey;
var pdfRed = '#DD1D01';
exports.pdfRed = pdfRed;
var wordBlue = '#2B579A';
exports.wordBlue = wordBlue;
var excelGreen = '#217346';
exports.excelGreen = excelGreen;
var powerPointRed = '#C03A1B';
exports.powerPointRed = powerPointRed;
var _default = {
  primary: primary,
  neutral: neutral,
  white: white,
  black: black,
  backgroundGrey: backgroundGrey,
  negative: negative,
  informative: informative,
  warning: warning,
  positive: positive,
  pdfRed: pdfRed,
  wordBlue: wordBlue,
  excelGreen: excelGreen,
  powerPointRed: powerPointRed
};
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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